export default {
    rounded: {
        borderRadius: '4px'
    },

    boxShadowCard: {
        // -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.15);
        // -moz-box-shadow: 0 1px 3px rgba(0,0,0,.15);
        boxShadow: '0 1px 3px rgba(0,0,0,.15)'
    }
    
};
  


// WEBPACK FOOTER //
// ./src/containers/CustomerAdd/style.js